import { Fragment, useEffect } from "react";
import Features from "./static/features";
import Contact from "./static/contact";
import Footer from "./static/footer";
import { useLocation } from "react-router-dom";

export const FeaturesPage = (props) => {
  const location = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0); // Scroll to the top when route changes
    const section = document.getElementById("features"); // Remove "#"
    if (section) {
      section.scrollIntoView({ behavior: "smooth", block: "start" });
    }
  }, [location.pathname]);

  return (
    <Fragment>
      <div className="home-page" style={{ width: "100%", height: "100%" }}>
        <Features />
        <Contact />
        <Footer />
      </div>
    </Fragment>
  );
};
